import { Component, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { LogService } from '../../../services/log.service';

@Component({
    selector: 'app-post-event',
    imports: [FormsModule],
    templateUrl: './post-event.component.html'
})
export class PostEventComponent {
  private log = inject(LogService);
  report = {
    realAttendees: null,
    wasteKg: null,
    satisfaction: null,
  };

  submit() {
    this.log.debug('Post event report:', this.report);
    // TODO: analyse + IA
  }
}
